var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "listTopImg" }, [
    this.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "tltTop-img-bar marginAuto positionRE" }, [
          _c("img", {
            staticClass: "tltTop-img",
            attrs: {
              src:
                _vm.imgType == "1"
                  ? _vm.src0
                  : _vm.imgType == "2"
                  ? _vm.src1
                  : _vm.imgType == "3"
                  ? _vm.src2
                  : _vm.imgType == "4"
                  ? _vm.src3
                  : _vm.imgType == "5"
                  ? _vm.src4
                  : "",
              alt: "",
              title: ""
            }
          }),
          _c("div", { staticClass: "content-Top" }, [
            _c("p", { staticClass: "font36px content-Top-tlt colffffff" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.imgType == "2"
                      ? "“体质管理+营养管理+作息管理”健康瘦身方案"
                      : _vm.imgType == "3"
                      ? "“体质管理+营养管理+作息管理”健康瘦身方案"
                      : _vm.imgType == "1"
                      ? "脂玫乐专业健康瘦身品牌"
                      : _vm.imgType == "4"
                      ? "脂玫乐 专业健康瘦身品牌"
                      : _vm.imgType == "5"
                      ? "健康瘦身，发现更好的自己"
                      : ""
                  )
              )
            ]),
            _c("p", { staticClass: "font26px content-Top-p colffffff" }, [
              _vm._v(
                _vm._s(
                  _vm.imgType == "2"
                    ? ""
                    : _vm.imgType == "3"
                    ? ""
                    : _vm.imgType == "1"
                    ? "健康瘦身，发现更好的自己"
                    : _vm.imgType == "4"
                    ? "健康瘦身，发现更好的自己"
                    : _vm.imgType == "5"
                    ? "健康瘦身，发现更好的自己"
                    : ""
                )
              )
            ])
          ])
        ])
      : _vm._e(),
    this.$store.state.webNavigator == "phone"
      ? _c(
          "div",
          { class: _vm.imgType != "5" ? "phone-imgBar" : "phone-imgBar2" },
          [
            _c("img", {
              class: _vm.imgType != "5" ? "phone-img" : "phone-img2",
              attrs: {
                src:
                  _vm.imgType == "1"
                    ? _vm.phone1
                    : _vm.imgType == "2"
                    ? _vm.phone2
                    : _vm.imgType == "3"
                    ? _vm.phone3
                    : _vm.imgType == "4"
                    ? _vm.phone4
                    : _vm.imgType == "5"
                    ? _vm.phone5
                    : "",
                alt: "",
                title: ""
              }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-431c7ae2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-431c7ae2","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/listTopImg/listTopImg.vue
// module id = 794
// module chunks = 3 4 5 6 7 8 9 10 12